module.exports = __webpack_public_path__ + "img/picker-self-on.3c619a61.png";